import CharacterHeaderMobile from './CharacterHeaderMobile';

export default CharacterHeaderMobile;
export { CharacterHeaderMobile };
